// 通知選單
import React from 'react';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { notificationState } from '@/slices/notificationSlice';
import { userState } from '@/slices/userSlice';

import NotifyComponent from './NotifyComponent'; // 通知元件
import EmptyNotification from './notify/EmptyNotification'; // 空值狀態

const NotifyModal = ({ setShowNotifyModal, showNotifyModal, t, locale, dispatch }) => {
    const { memberUrl } = useSelector(urlState);
    const { notification } = useSelector(notificationState);
    const { user } = useSelector(userState);

    // 關閉
    const onClose = () => dispatch(setShowNotifyModal(false));

    return (
        <>
            <div
                className={`p-[20px] z-[20] absolute right-[4px] rounded-[12px] bg-[rgba(0,0,0,.70)] backdrop-blur-[10px] w-[266px]
            trans ulg:fixed ${
                showNotifyModal ? 'top-[55px] ulg:[54px]' : 'top-[-500px]'
            } ulg:w-full ulg:right-[0] ulg:rounded-[0] ulg:shadow-none ulg:border-b-1 ulg:border-black9`}
            >
                <p className="text-h5 text-white pb-[22px] text-center">{t('NOTIFY')}</p>

                {notification?.records && notification?.records?.length ? (
                    <>
                        {notification?.records?.slice(0, 3).map((notify, i) => (
                            <React.Fragment key={`notify_${notify.id}_${i}`}>
                                {/* 通知元件 */}
                                <NotifyComponent
                                    t={t}
                                    onClose={onClose}
                                    notify={notify}
                                    locale={locale}
                                    uid={user?.uid}
                                />
                            </React.Fragment>
                        ))}

                        {/* 查看更多 */}
                        <a
                            href={memberUrl + 'notification-center'}
                            onClick={onClose}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="text-btn1 text-white rounded-[4px] py-[12px] text-center block w-full trans bg-bou hover:bg-white hover:text-bou mt-[6px]"
                        >
                            {t('MORE')}
                        </a>
                    </>
                ) : (
                    // 空值狀態
                    <EmptyNotification t={t} />
                )}
            </div>

            {showNotifyModal && (
                <>
                    <div className="fixed top-0 left-0 w-full h-[54px] z-[22]" onClick={onClose} />
                    <div className="fixed top-0 left-0 z-[8] w-full h-full" onClick={onClose} />
                </>
            )}
        </>
    );
};

export default NotifyModal;
